import { lazy } from "react";
import { useNavigate } from "react-router-dom";

/**
 * @type {{
    path: string;
    component:React.LazyExoticComponent<({ state, to, title }: {
        state: any;
        to?: string;
        title?: string;
    }) => React.JSX.Element>;
    temp: string;
    featureFlag?: string | undefined;
    subpage?: {
    path: string;
    component:React.LazyExoticComponent<({ state, to, title }: {
        state: any;
        to?: string;
        title?: string;
    }) => React.JSX.Element>;
    temp: string;
    featureFlag?: string | undefined;
    }[] | undefined;
}[]}
 */
const pages = [
  {
    path: "/auth/:provider/callback",
    component: lazy(() => import("./views/auth/OAuthCallback.jsx")),
    temp: "OAuthCallback",
  },
];

function getRoutes(pagesList) {
  return pagesList.reduce(
    (processedPages, { path, component, subpage, ...rest }) => {
      let children;
      if (subpage !== undefined) {
        children = getRoutes(subpage);
      }
      const processedPage = {
        path,
        component,
        ...rest,
        ...(children ? { children } : {}),
      };

      processedPages.push(processedPage);
      return processedPages;
    },
    []
  );
}

export const routes = getRoutes(pages);
